import { Link } from "react-router-dom";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const resolveImg = (p) => !p ? undefined : (p.startsWith("http") ? p : `${BACKEND}${p}`);

export function formatDate(iso) {
    if (!iso) return "";
    return new Date(iso).toLocaleDateString("fr-FR", { day: "2-digit", month: "long", year: "numeric" });
}

const CATEGORY_LABEL = {
    concert: "Concert",
    brocante: "Brocante",
    "marche-createurs": "Marché créateurs",
    expo: "Exposition",
    food: "Food",
    fete: "Fête",
    "retraite-bien-etre": "Retraite",
    soiree: "Soirée",
    saisonnier: "Saisonnier",
};

export default function EventCard({ event, variant = "default" }) {
    if (variant === "wide") {
        return (
            <Link
                to={`/evenements/${event.slug}`}
                data-testid={`event-card-wide-${event.slug}`}
                className="group grid grid-cols-1 md:grid-cols-[320px_1fr_auto] gap-8 md:gap-12 py-10 md:py-12 border-b border-cp-border items-center hover:bg-cp-craie transition-colors px-2 md:px-4 -mx-2 md:-mx-4"
            >
                <div className="cp-image-zoom aspect-[4/3] overflow-hidden bg-cp-craie">
                    <img src={resolveImg(event.image)} alt={event.title} loading="lazy" className="w-full h-full object-cover cp-photo-warm" />
                </div>
                <div>
                    <p className="cp-tiny text-cp-sable-deep mb-3">{CATEGORY_LABEL[event.category] || event.category}</p>
                    <h3 className="cp-serif text-3xl md:text-5xl leading-[0.98] text-cp-encre mb-4 group-hover:italic transition-all">
                        {event.title}
                    </h3>
                    <p className="cp-serif italic text-lg text-cp-gris leading-snug max-w-2xl mb-4">{event.short_description}</p>
                    <p className="cp-mono text-xs text-cp-gris">{formatDate(event.start_date)} · {event.location_name}</p>
                </div>
                <div className="text-right hidden md:flex flex-col items-end gap-3">
                    {event.price && <span className="cp-mono text-xs text-cp-foret">{event.price}</span>}
                    <span className="cp-tiny text-cp-encre opacity-0 group-hover:opacity-100 transition-opacity">Lire →</span>
                </div>
            </Link>
        );
    }
    return (
        <Link to={`/evenements/${event.slug}`} data-testid={`event-card-${event.slug}`} className="group block">
            <div className="cp-image-zoom aspect-[3/4] overflow-hidden bg-cp-craie mb-5">
                <img src={resolveImg(event.image)} alt={event.title} loading="lazy" className="w-full h-full object-cover cp-photo-warm" />
            </div>
            <p className="cp-tiny text-cp-sable-deep mb-2">{CATEGORY_LABEL[event.category] || event.category}</p>
            <h3 className="cp-serif text-2xl md:text-3xl leading-tight text-cp-encre group-hover:italic transition-all">{event.title}</h3>
            <p className="cp-mono text-xs text-cp-gris mt-3">{formatDate(event.start_date)}</p>
        </Link>
    );
}
